/* eslint-disable max-classes-per-file */
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { ActionConstants } from '../../constants/action-constants';
import { getGeneralNamePatterns } from '../../shared/utils/validation.util';

@Metamodel.model({
    name: 'Metadata'
})
export class ScriptMetadata {

    @Metamodel.attribute({
        display: 'language',
        constraint: {
            required: true
        }
    })
    public language: string;
}

@Metamodel.model({
    name: 'SQL Script Connection Key'
})
export class SqlScriptConnectionKey {

    @Metamodel.attribute({
        display: 'name'
    })
    public name?: string;

    @Metamodel.attribute({
        display: 'type'
    })
    public type?: 'SqlOnDemand' | 'SqlCompute' | 'SqlPool';
}

@Metamodel.model({
    name: 'SQL Script Connection Key for SQL V3'
})
export class SqlScriptConnectionKeyV3 {

    @Metamodel.attribute({
        display: 'poolName'
    })
    public poolName?: string;

    @Metamodel.attribute({
        display: 'poolType'
    })
    public poolType?: 'dedicated' | 'serverless' | 'unified';

    @Metamodel.attribute({
        display: 'databaseName'
    })
    public databaseName?: string;
}

@Metamodel.model({
    name: 'SQL Script Content'
})
export class SqlScriptContent {

    @Metamodel.attribute({
        display: 'query'
    })
    public query?: string;

    @Metamodel.attribute({
        display: 'metadata'
    })
    public metadata?: ScriptMetadata;

    @Metamodel.attribute({
        display: 'currentConnection'
    })
    public currentConnection?: SqlScriptConnectionKey | SqlScriptConnectionKeyV3;

    @Metamodel.attribute({
        display: 'resultLimit'
    })
    public resultLimit?: number;
}

@Metamodel.model({
    name: ModelConstants.sqlScript,
    display: [shellStringResources.SynapseSqlScript, shellStringResources.SynapseSqlScripts],
    reusable: true,
    referable: true,
    validator: SqlScript.validate,
    constraints: {
        name: {
            required: true,
            patterns: getGeneralNamePatterns(shellStringResources.SynapseSqlScript),
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.sqlScriptsWrite
        },
        deleteResource: {
            action: ActionConstants.sqlScriptsDelete
        }
    }
})
export class SqlScript extends A365Named {
    public readonly useShellFolder: boolean = true;

    @Metamodel.attribute({
        display: 'query'
    })
    public content?: SqlScriptContent;

    // eslint-disable-next-line
    @Metamodel.attribute({
        display: 'type'
    })
    public type?: string;

    public runQueryOnOpen?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);

        this.description = description || '';
        this.content = new SqlScriptContent();
        this.content.metadata = new ScriptMetadata();
        this.content.metadata.language = 'sql';
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        return undefined;
    }
}
